import { render, staticRenderFns } from "./CampanhaPasso4.vue?vue&type=template&id=11992bb0&scoped=true"
import script from "./CampanhaPasso4.vue?vue&type=script&lang=js"
export * from "./CampanhaPasso4.vue?vue&type=script&lang=js"
import style0 from "./CampanhaPasso4.vue?vue&type=style&index=0&id=11992bb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11992bb0",
  null
  
)

export default component.exports